"use strict";

class CampaignOverviewCtrl {

    constructor(
        $scope,
        $rootScope,
        $http,
        $timeout,
        Campaign,
        $mdDialog,
        $mdToast,
        $state,
        $filter,
        itemFilters,
        filterMap,
        paginationService,
        $transitions
    ) {

        // Dependencies
        this.$http = $http;
        this.$timeout = $timeout;
        this._Campaign = Campaign;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$state = $state;

        // Controller vars
        this.$filter = $filter;
        this.itemFilters = itemFilters;
        this.filterMap = filterMap;
        this.filterCount = 0;
        this.loaded = false;
        this.paginationService = paginationService;
        this.paginationId = this.paginationService.getLastInstanceId();

        this.formdata = {
            item_data: {}
        };

        // Paginator
        this.pagination = {
            current: 1
        };

        // Watchers
        let unregister = $transitions.onSuccess({}, function (transition) {

            let toState = transition.to();
            if (toState.name === 'campaign') {
                this.fetch();
            }
        });

        $scope.$on('$destroy', () => {
            unregister();
        });

        // Fetch the overview items
        if ($state.params.id) {
            $http.get('/campaigns/findpage/' + $state.params.id).then((response) => {
                this.fetch(response.data);
                this.pagination.current = response.data;
            });
        } else {
            this.fetch(1);
        }
    }


    fetch(pageNumber) {

        let filters = [];
        this.filterMap.map((filter) => {

            if (filter.enabled) {
                filters.push(filter.id);
            }
        });

        this.loaded = false;
        this.$http.get('/campaigns_overview/?page=' + (pageNumber || 1) + '&filters=' + filters)
            .then((response) => {
                this.campaigns = response.data.data;
                this.totalResults = response.data.total;
                this.resultPerPage = response.data.per_page;
                this.$timeout(() => {
                    this.loaded = true;
                });

            });

        this.$http.get('/modeltypes_options/campaign')
            .then((response) => {
                this.campaign_options = response.data;
            });

    }


    destroy(id, count, title, ev) {

        ev.stopPropagation();

        let pageN = this.paginationService.getCurrentPage(this.paginationId);

        this.$mdDialog.show({

            controller: 'ConfirmManyDialogCtrl',
            templateUrl: 'confirmManyDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                count: count,
                option: null,
            }
        }).then(() => {

            this.loaded = false;
            this._Campaign.delete({id: id}, () => {
                this.fetch();
                this.$state.go('campaign');
            });

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=campaign&title=' + title, //@trans('labels.campaign')
                hideDelay: 3000,
                position: ('top right')
            });
        });
    }


    /**
     * Returns true or false depending on if the item.model_type_id is in the filterArray
     * @return {boolean}
     */
    updateFilters() {

        let filters = [];
        this.filterMap.map((filter) => {
            if (!filter.enabled) {
                filters.push(filter.id);
            }
        });

        this.$http.post('/userfilters/campaign', {
            campaign_filter: filters
        }).then(() => {
            this.fetch(1);
        });
    }


    checkActive(contact) {
        return contact.id == this.$state.params.id;
    };
}

CampaignOverviewCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$http',
    '$timeout',
    'Campaign',
    '$mdDialog',
    '$mdToast',
    '$state',
    '$filter',
    'itemFilters',
    'filterMap',
    'paginationService',
    '$transitions'
];

module.exports = CampaignOverviewCtrl;
